/**
 * @author Iulian Ceapa <dev@sitemd.net>
 * @copyright © 2019-2026 SiteMD.
 */

Fancybox.bind('[data-fancybox]', {});

const swiper_section_5 = new Swiper('#section-5 .swiper', {
    // autoHeight: true,
    // centeredSlides: true,
    // breakpoints: {
    //     0: {
    //         slidesPerView: 'auto',
    //         spaceBetween: 16
    //     },
    //     768: {
    //         slidesPerView: 2,
    //         spaceBetween: 16
    //     },
    //     992: {
    //         slidesPerView: 3,
    //         spaceBetween: 24
    //     }
    // },
    // speed: 600,
    // effect: 'creative',
    // creativeEffect: {
    //     prev: {
    //         shadow: true,
    //         translate: ['-120%', 0, -500],
    //     },
    //     next: {
    //         shadow: true,
    //         translate: ['120%', 0, -500],
    //     },
    // },
    grabCursor: true,
    slidesPerView: 'auto',
    // initialSlide: 1,
    // pagination: {
    //     el: '.swiper-pagination',
    // },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    spaceBetween: 32
    // loop: true
});

const swiper_section_6 = new Swiper('#section-6 .swiper', {
    // autoHeight: true,
    // centeredSlides: true,
    // breakpoints: {
    //     0: {
    //         slidesPerView: 'auto',
    //         spaceBetween: 16
    //     },
    //     768: {
    //         slidesPerView: 2,
    //         spaceBetween: 16
    //     },
    //     992: {
    //         slidesPerView: 3,
    //         spaceBetween: 24
    //     }
    // },
    // speed: 600,
    // effect: 'creative',
    // creativeEffect: {
    //     prev: {
    //         shadow: true,
    //         translate: ['-120%', 0, -500],
    //     },
    //     next: {
    //         shadow: true,
    //         translate: ['120%', 0, -500],
    //     },
    // },
    grabCursor: true,
    slidesPerView: 'auto',
    // initialSlide: 1,
    // pagination: {
    //     el: '.swiper-pagination',
    // },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    spaceBetween: 32
    // loop: true
});